(function ($) {

    var storeDataInMonthsField  = $('#store_data_in_months:not(.disabled)');
    var selectedMonths = storeDataInMonthsField.val();

    $('.confirm-avg-delete').click(function (event) {
        event.preventDefault();
        $('#avgModalDeleteConfirmationModal').modal('show');
    });

    storeDataInMonthsField.change(function () {
        if (this.value == 3) {
            let $modal = $('#avgModalThreeMonthsConfirmationModal');
            $modal.find('.months-from').html(selectedMonths);
            $modal.modal('show');
        } else {
            let $modal = $('#avgModalTwelveMonthsConfirmationModal');
            $modal.find('.months').html(this.value);
            $modal.find('.months-from').html(selectedMonths);
            $modal.modal('show');
        }
    });

    $('.cancel-avg-submit-form').click(function () {
        storeDataInMonthsField.val(selectedMonths);
    });

    $('.submit-avg-delete-form').click(function () {
        $('#avg-delete-form form').submit();
    });

    $('.submit-avg-form').click(function () {
        $('#avg-form form').submit();
    });

})(jQuery);

